// function to be added to OpenLayers.View.prototype if needed
// 'this' in the function is the view object

const getScaleFromResolution = function (resolution, opt_round) {
    var projection = this.getProjection(),
        units = projection.getUnits(),
        INCHES_PER_UNIT = {
            'm':       39.37,
            'us-ft':    12,
            'dd': 4374754
        },
        DOTS_PER_INCH = 72,
        scale = INCHES_PER_UNIT[units] * DOTS_PER_INCH * resolution;

    if (opt_round) {
        scale = Math.round(scale);
    }
    return scale;
}

export default getScaleFromResolution;
